import React from "react";
import { Link } from "react-router-dom";
import "./NavBar.scss";
import { ReactComponent as LogoLight } from "../../../assets/images/spark-notifications-logo.svg";
import { User } from "@livingdesign/icons";
import UserMenu from "../UserMenu/UserMenu";
import TeamSelector from "../TeamSelector/TeamSelector";

const QA_ID_PREFIX = "NavBar";

function NavBar({
  user,
}) {
  return (
    <div className="main-nav-bar" data-testid={`${QA_ID_PREFIX}-Container`}>
      <div
        className="sn-logo-container"
        data-testid={`${QA_ID_PREFIX}-SNLogo-Container`}
        id={`${QA_ID_PREFIX}-SNLogo-Container`}
      >
        <Link to="/" data-testid={`${QA_ID_PREFIX}-SNLogo-Link`}>
          <LogoLight
            id={`${QA_ID_PREFIX}-SNLogo-LightMode`}
            data-testid={`${QA_ID_PREFIX}-SNLogo-LightMode`}
          />
        </Link>
      </div>

      <div className="nav-right-section" data-testid={`${QA_ID_PREFIX}-RightSection`}>
        <TeamSelector />
        <UserMenu
          user={user}
          id={`${QA_ID_PREFIX}-UserMenu`}
          data-testid={`${QA_ID_PREFIX}-UserMenu`}
        />
      </div>
    </div>
  );
}

export default NavBar;
